import { ImageOptimized } from '../../../components/image/ImageOptimized';
import { SearchResult } from 'functions/src/types/firestore/Search';
import { SearchResultBase } from './SearchResultBase';

export type GameSearchResultProps = SearchResult & { category: 'game' };

export const GameSearchResult = ({
  game,
  title,
  description,
  objectID,
}: GameSearchResultProps) => {
  const gameUrl = `/game/${objectID}`;

  return (
    <SearchResultBase
      href={gameUrl}
      imageSx={{
        display: 'flex',
        flexGrow: 0,

        minWidth: 90,
        minHeight: 90,
        borderRadius: '4px',
      }}
      image={
        <ImageOptimized
          src={game.imgUrl}
          alt=""
          width={90}
          height={90}
          style={{ borderRadius: '4px' }}
        />
      }
      header={title}
      description={description}
      category={'Game'}
    />
  );
};
